export const DEFAULT_LOCALE = "en-us";
export const ROWS_PER_PAGE: number[] = [5, 10, 15];
